<span *ngIf="item.IsAct48 == 1" role="img" [attr.aria-label]="item.Act48SubInErr ? 'Act 48 submission error - action required' : 'Act 48 tracking enabled'">
    <i class="fas fa-clock" [class.action-required]="item.Act48SubInErr" aria-hidden="true"></i>
</span>
